import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

const Communicate = Loader(
  lazy(() => import('content/informative/Communicate'))
);

const SingleCommunicate = Loader(
  lazy(
    () => import('content/informative/Communicate/single/CommunicateSingleView')
  )
);

const SingleCommunicateCreate = Loader(
  lazy(() => import('content/informative/Communicate/CreateCommunication'))
);

const EmailTemplates = Loader(
  lazy(() => import('content/informative/EmailTemplates'))
);

const EmailTemplateCreate = Loader(
  lazy(() => import('content/informative/EmailTemplates/CreateEmailTemplate'))
);

const SingleEmailTemplate = Loader(
  lazy(
    () =>
      import(
        'content/informative/EmailTemplates/single/ViewEmailTemplateDialogProps'
      )
  )
);

const RecipientGroups = Loader(
  lazy(() => import('content/informative/RecipientGroups'))
);

const SingleRecipientGroups = Loader(
  lazy(() => import('content/informative/RecipientGroups/single'))
);

const Recipients = Loader(lazy(() => import('content/informative/Recipients')));

const SingleRecipients = Loader(
  lazy(() => import('content/informative/Recipients/single'))
);

const informativeRoutes = [
  {
    path: '',
    element: <Navigate to="/informative" replace />,
  },
  {
    path: 'communicate',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: <Communicate />,
      },
      {
        path: 'single',
        children: [
          {
            path: '',
            element: <Navigate to="1" replace />,
          },
          {
            path: ':communicationId',
            element: <SingleCommunicate />,
          },
        ],
      },
      {
        path: 'create',
        element: <SingleCommunicateCreate />,
      },
    ],
  },
  {
    path: 'email-templates',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: <EmailTemplates />,
      },
      {
        path: 'create',
        element: <EmailTemplateCreate />,
      },
      {
        path: 'single',
        children: [
          {
            path: '',
            element: <Navigate to="1" replace />,
          },
          {
            path: ':templateId',
            element: <SingleEmailTemplate />,
          },
        ],
      },
    ],
  },
  {
    path: 'recipient-groups',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: <RecipientGroups />,
      },
      {
        path: 'single',
        children: [
          {
            path: '',
            element: <Navigate to="1" replace />,
          },
          {
            path: ':recipientGroupId',
            element: <SingleRecipientGroups />,
          },
        ],
      },
    ],
  },
  {
    path: 'recipients',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: <Recipients />,
      },
      {
        path: 'single',
        children: [
          {
            path: '',
            element: <Navigate to="1" replace />,
          },
          {
            path: ':recipientId',
            element: <SingleRecipients />,
          },
        ],
      },
    ],
  },
];

export default informativeRoutes;
